import React from 'react';
export type IconProps = {
  className?: string;
  strokeWidth?: number;
};
type SvgProps = IconProps & {
  children: React.ReactNode;
  title?: string;
};
function Svg({
  className = 'h-6 w-6',
  strokeWidth = 1.2,
  children
}: SvgProps) {
  return <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" focusable="false" data-id="element-153" data-mp="2ej1e0zfwv7r9">
      {children}
    </svg>;
}
export function CrownIcon(props: IconProps) {
  return <Svg {...props} data-id="element-154" data-mp="1qtgm3r1s505u">
      <path d="M4 22l-1.6-12 6.4 4.6L16 6l7.2 8.6L29.6 10 28 22z" data-id="element-155" data-mp="1qsxdj0y0ro4h" />
      <path d="M4 22h24" data-id="element-156" data-mp="1vqp2bm3dau4g" />
      <path d="M9 26h14" data-id="element-157" data-mp="1vqgsk32jk4xh" />
      <circle cx="16" cy="4" r="1.1" data-id="element-158" data-mp="1ztdea2ndoh5n" />
    </Svg>;
}
export function ScissorsIcon(props: IconProps) {
  return <Svg {...props} data-id="element-159" data-mp="376x7zwe3ilkc">
      <circle cx="7" cy="24" r="3.4" data-id="element-160" data-mp="377ov0itmnaz0" />
      <circle cx="25" cy="24" r="3.4" data-id="element-161" data-mp="376nj6c4sekg8" />
      <path d="M9.6 21.6L23 4" data-id="element-162" data-mp="3b88qzj2gs8jk" />
      <path d="M22.4 21.6L9 4" data-id="element-163" data-mp="3b7h9td9m6dct" />
      <path d="M16 14.5l2.6 3.4" data-id="element-164" data-mp="3baljgq5um1av" />
    </Svg>;
}
export function BlowoutIcon(props: IconProps) {
  return <Svg {...props} data-id="element-165" data-mp="2q39zix8z517u">
      <path d="M3 10h15a4 4 0 100-4" data-id="element-166" data-mp="2l69rwhwh7qem" />
      <path d="M3 16h20a4 4 0 110 8" data-id="element-167" data-mp="2l7b6uxgm4x1m" />
      <path d="M3 22h9a3 3 0 110 6" data-id="element-168" data-mp="2l46rr51m0gw6" />
    </Svg>;
}
export function ColorIcon(props: IconProps) {
  return <Svg {...props} data-id="element-169" data-mp="2g99m883jgpo1">
      <path d="M16 3c7 0 13 5 13 11.2 0 4-3 6.3-6.6 6.3h-2.5c-1.9 0-3.2 1.4-3.2 3 0 .8.3 1.4.7 2 .4.6.7 1.2.7 1.9 0 1.4-1.1 2.6-2.6 2.6C8.1 30 3 23.9 3 16.4 3 8.9 8.8 3 16 3z" data-id="element-170" data-mp="2c5lbxhnivfz3" />
      <circle cx="10.5" cy="13" r="1.5" data-id="element-171" data-mp="278l534ium96x" />
      <circle cx="16" cy="9.5" r="1.5" data-id="element-172" data-mp="22fibiwe2mzqq" />
      <circle cx="21.5" cy="13" r="1.5" data-id="element-173" data-mp="22egywnheq56w" />
    </Svg>;
}
export function TreatmentIcon(props: IconProps) {
  return <Svg {...props} data-id="element-174" data-mp="1xem9koda5nny">
      <path d="M16 3c5 5.6 8 9.7 8 13.6A8 8 0 0116 25a8 8 0 01-8-8.4C8 12.7 11 8.6 16 3z" data-id="element-175" data-mp="1shm52hw2wsyy" />
      <path d="M12.5 17.5c0 2.2 1.6 3.8 3.5 4.1" data-id="element-176" data-mp="1sfriz092muta" />
      <path d="M16 25v4" data-id="element-177" data-mp="1oepf2647lukz" />
    </Svg>;
}
export function ExtensionsIcon(props: IconProps) {
  return <Svg {...props} data-id="element-178" data-mp="1jhz0xobyt927">
      <path d="M8 4c-2.6 4.6-3.4 9-2.4 13.4C6.4 21.4 8 25 8 29" data-id="element-179" data-mp="1jhpkosgq2g9p" />
      <path d="M16 3c-3 5.4-3.8 10.6-2.4 15.6C14.6 22.6 16 26 16 29" data-id="element-180" data-mp="19t22p748zuco" />
      <path d="M24 4c2.6 4.6 3.4 9 2.4 13.4C25.6 21.4 24 25 24 29" data-id="element-181" data-mp="1dux1o4yphvna" />
      <path d="M6 11h20" data-id="element-182" data-mp="1dw85u5w2d5ex" />
    </Svg>;
}
export function EventIcon(props: IconProps) {
  return <Svg {...props} data-id="element-183" data-mp="zwysddz8spen">
      <path d="M16 2.5l2.9 7.4 7.9.5-6.1 5 2 7.7L16 18.9l-6.7 4.2 2-7.7-6.1-5 7.9-.5z" data-id="element-184" data-mp="zxgwews5c7x4" />
      <path d="M8 27l3-1.4 3 1.4" data-id="element-185" data-mp="14wbefwiahsg6" />
      <path d="M18 27l3-1.4 3 1.4" data-id="element-186" data-mp="1sj9rek77ai9c" />
    </Svg>;
}
export function SparkleIcon(props: IconProps) {
  return <Svg {...props} data-id="element-187" data-mp="1xjea8gvkzp2q">
      <path d="M16 3c.9 6.6 2.9 10.4 13 13-10.1 2.6-12.1 6.4-13 13-.9-6.6-2.9-10.4-13-13 10.1-2.6 12.1-6.4 13-13z" data-id="element-188" data-mp="1xhutkp60jc0f" />
    </Svg>;
}
export function ChemicalIcon(props: IconProps) {
  return <Svg {...props} data-id="element-189" data-mp="1nsb95f2nja3g">
      <path d="M13 3h6" data-id="element-190" data-mp="1nrs24teji647" />
      <path d="M14 3v8.4L7.6 24.2A3 3 0 0010.3 29h11.4a3 3 0 002.7-4.8L18 11.4V3" data-id="element-191" data-mp="1nr05rgd4c4cv" />
      <path d="M10.5 20h11" data-id="element-192" data-mp="2bh2x1u97l6af" />
      <circle cx="14" cy="24" r="1.1" data-id="element-193" data-mp="2bgugnsdvniuh" />
      <circle cx="19" cy="25" r="1.1" data-id="element-194" data-mp="2g9nk8cxm0l4z" />
    </Svg>;
}
export function PhoneIcon(props: IconProps) {
  return <Svg {...props} data-id="element-195" data-mp="4tdbmr55o6c0">
      <path d="M11.6 4.5l3 5-2.6 2.6c1.4 3 3.9 5.5 6.9 6.9l2.6-2.6 5 3-1.4 4.2c-.4 1.2-1.6 2-2.9 1.8C13.6 24 8 18.4 6.6 8.8c-.2-1.3.6-2.5 1.8-2.9z" data-id="element-196" data-mp="4su6yc4inefx" />
    </Svg>;
}
export function MobileIcon(props: IconProps) {
  return <Svg {...props} data-id="element-197" data-mp="dlxigevlph7x">
      <rect x="9" y="2.5" width="14" height="27" rx="3" data-id="element-198" data-mp="9l3q99b4lg98" />
      <path d="M14 6h4" data-id="element-199" data-mp="9lnaiwo90gqf" />
      <path d="M14.5 25.5h3" data-id="element-200" data-mp="9n81ydf9njk2" />
    </Svg>;
}
export function PinIcon(props: IconProps) {
  return <Svg {...props} data-id="element-201" data-mp="3i31941npjiog">
      <path d="M16 29s10-8.6 10-16A10 10 0 006 13c0 7.4 10 16 10 16z" data-id="element-202" data-mp="3d1u2w717qrjw" />
      <circle cx="16" cy="13" r="3.6" data-id="element-203" data-mp="3d3omni0r0dme" />
    </Svg>;
}
export function InstagramIcon(props: IconProps) {
  return <Svg {...props} data-id="element-204" data-mp="3qzinreva5yoy">
      <rect x="4" y="4" width="24" height="24" rx="7" data-id="element-205" data-mp="3m2ij98e2x3zy" />
      <circle cx="16" cy="16" r="6" data-id="element-206" data-mp="3m0z11c8v4ivj" />
      <circle cx="23" cy="9" r="1.2" data-id="element-207" data-mp="16be2ao55npsj" />
    </Svg>;
}
export function TikTokIcon(props: IconProps) {
  return <Svg {...props} data-id="element-208" data-mp="11cb6lub2evx8">
      <path d="M19.2 4.5c.5 3.2 2.6 5.2 5.8 5.5v4.3c-2.1.1-4.1-.5-5.8-1.7v7.2a7.6 7.6 0 11-6.6-7.5v4.4a3.2 3.2 0 102.6 3.1V4.5h4z" data-id="element-209" data-mp="11d2tmgqljlbw" />
    </Svg>;
}
export function MailIcon(props: IconProps) {
  return <Svg {...props} data-id="element-210" data-mp="21l15zmgfnflo">
      <rect x="3" y="7" width="26" height="18" rx="3" data-id="element-211" data-mp="21mc8zk220jbq" />
      <path d="M4 9l12 8 12-8" data-id="element-212" data-mp="26knjzy434zvj" />
    </Svg>;
}
export function ClockIcon(props: IconProps) {
  return <Svg {...props} data-id="element-213" data-mp="2bjqqzo3mlg65">
      <circle cx="16" cy="16" r="12.5" data-id="element-214" data-mp="2bk9y09rqmk5e" />
      <path d="M16 8.5V16l5 3" data-id="element-215" data-mp="2blbgv0ezwaxo" />
    </Svg>;
}
export function CheckIcon(props: IconProps) {
  return <Svg {...props} data-id="element-216" data-mp="2fksoo0hw9k60">
      <path d="M5 17l7 7L27 8" data-id="element-217" data-mp="2fj9786ki532n" />
    </Svg>;
}
export function CrossIcon(props: IconProps) {
  return <Svg {...props} data-id="element-218" data-mp="2kic3b1ii7yyh">
      <path d="M8 8l16 16M24 8L8 24" data-id="element-219" data-mp="2pb5cc1l09tgd" />
    </Svg>;
}
export function StarIcon({
  className = 'h-4 w-4'
}: IconProps) {
  return <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true" data-id="element-220" data-mp="2uahu47x0sac3">
      <path d="M16 2.5l4.2 8.9 9.3 1.3-6.8 6.9 1.6 9.9L16 24.9 7.7 29.5l1.6-9.9-6.8-6.9 9.3-1.3z" data-id="element-221" data-mp="2z9uqbj9s6trc" />
    </svg>;
}
export function QuoteIcon({
  className = 'h-8 w-8'
}: IconProps) {
  return <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true" data-id="element-222" data-mp="rnb75hpd7eou">
      <path d="M12.6 6C7.6 8.4 4.6 12.7 4.6 18.2c0 4.5 2.5 7.8 6.2 7.8 3 0 5.2-2.2 5.2-5.1 0-2.9-2-5-4.8-5-.5 0-1 .1-1.3.2.6-2.9 2.6-5.4 5.6-7zM27.2 6c-5 2.4-8 6.7-8 12.2 0 4.5 2.5 7.8 6.2 7.8 3 0 5.2-2.2 5.2-5.1 0-2.9-2-5-4.8-5-.5 0-1 .1-1.3.2.6-2.9 2.6-5.4 5.6-7z" data-id="element-223" data-mp="nlzf75j0qhdh" />
    </svg>;
}
export function MenuIcon(props: IconProps) {
  return <Svg {...props} data-id="element-224" data-mp="1bbtq3hjs1vv3">
      <path d="M4 9h24M4 16h24M4 23h24" data-id="element-225" data-mp="1bb0qr1n5e8mz" />
    </Svg>;
}
export function CloseIcon(props: IconProps) {
  return <Svg {...props} data-id="element-226" data-mp="16cz7ogpq29bi">
      <path d="M7 7l18 18M25 7L7 25" data-id="element-227" data-mp="16ek0o1we1k79" />
    </Svg>;
}
export function ArrowIcon(props: IconProps) {
  return <Svg {...props} data-id="element-228" data-mp="11je66eox6x7k">
      <path d="M5 16h22" data-id="element-229" data-mp="wmxhnjdt6gty" />
      <path d="M20 9l7 7-7 7" data-id="element-230" data-mp="wlmhdtjknr7l" />
    </Svg>;
}